import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor(private readonly datePipe: DatePipe) { }

  formatDateValue(date: string, format: string | null): string {
    if (!format) {
      format = 'dd/MM/yyyy HH:mm:ss';
    }
    return this.datePipe.transform(date, format) ?? '';
  }

  toMomentFormat(format: string): string {
    return format
      .replace(/dd/g, 'DD')
      .replace(/d/g, 'D')
      .replace(/yyyy/g, 'YYYY')
      .replace(/hh/g, 'HH')
      .replace(/h/g, 'H');
  }

  cleanFormat(rawFormat: string): string {
    const normalized = rawFormat.trim();

    if (!normalized) {
      return '';
    }

    const dateFormatEndIndex  = normalized.search(/\s+/);
    if (dateFormatEndIndex  === -1) {
      return normalized;
    }

    return normalized.substring(0, dateFormatEndIndex ).trim();
  }
}
